<template>
    <!-- Circular initials avatar — used in the SideNav's user footer. -->
    <span :style="rootStyle">{{ initials }}</span>
</template>

<script>
const PALETTE = [
    "oklch(0.72 0.13 25)", "oklch(0.72 0.13 65)", "oklch(0.70 0.13 145)",
    "oklch(0.68 0.13 215)", "oklch(0.70 0.13 275)", "oklch(0.72 0.13 340)",
];

function colorFor(name) {
    if (!name) return PALETTE[0];
    let h = 0;
    for (let i = 0; i < name.length; i++) h += name.charCodeAt(i);
    return PALETTE[h % PALETTE.length];
}

export default {
    name: "Avatar",
    props: {
        name: { type: String, default: "" },
        size: { type: Number, default: 22 },
        color: { type: String, default: null },
    },
    computed: {
        initials() {
            const n = (this.name || "").trim();
            if (!n) return "?";
            return n
                .split(/\s+/)
                .slice(0, 2)
                .map((s) => s[0] || "")
                .join("")
                .toUpperCase();
        },
        rootStyle() {
            return {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: `${this.size}px`,
                height: `${this.size}px`,
                borderRadius: "50%",
                background: this.color || colorFor(this.name),
                color: "#fff",
                fontSize: `${Math.round(this.size * 0.42)}px`,
                fontWeight: 600,
                letterSpacing: "0.01em",
                flex: `0 0 ${this.size}px`,
            };
        },
    },
};
</script>
